export default __webpack_public_path__ + "static/media/GR00036-mentor_amulet_5.28ccab7c.svg";